import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "BaseItemDialog__section-header bg-white mb-n-2px" }
const _hoisted_2 = { class: "fs-15px fw-600 text-cool-gray-100 block q-mb-sm" }
const _hoisted_3 = { class: "BaseItemDialog__section-body flex column no-wrap gap-md" }

import { reactive } from 'vue'
import { formatMonetaryAmount } from 'src/common/helpers/generator/monetaryAmount.helper'

interface IVariation {
  name: string
  options: IVariationOption[]
}

interface IVariationOption {
  option: string
  price: number
  cost: number
  stock: number
}

interface IState {
  variations: IVariation[]
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseItemDialogVariations' },
  __name: 'BaseItemDialogVariations',
  props: { currency: { type: String, required: true } },
  setup(__props) {


const props = __props

const tableColumnClasses = {
  headerClasses: 'q-px-sm',
  labelClasses: 'fs-13px text-cool-gray-100',
}

const columns = [
  {
    label: 'Options',
    align: 'left',
    field: 'option',
    name: 'option',
    style: 'width: 40%',
    ...tableColumnClasses,
  },
  {
    label: 'Cost',
    align: 'left',
    field: (row: IVariationOption) => formatMonetaryAmount(row.cost, props.currency),
    slot: 'cost',
    name: 'cost',
    ...tableColumnClasses,
  },
  {
    label: 'Price',
    align: 'left',
    field: (row: IVariationOption) => formatMonetaryAmount(row.price, props.currency),
    slot: 'price',
    name: 'price',
    ...tableColumnClasses,
  },
  {
    label: 'Stock',
    align: 'left',
    field: 'stock',
    name: 'stock',
    slot: 'stock',
    ...tableColumnClasses,
  },
]

const state = reactive<IState>({ variations: [] })

// NOTE: Below are the static data used for populating the tables. They should be removed once the data is provided via API
state.variations = [
  {
    name: 'Size',
    options: [
      {
        option: 'Small',
        price: 0,
        cost: 0,
        stock: 10,
      },
      {
        option: 'Medium',
        price: 0,
        cost: 0,
        stock: 10,
      },
      {
        option: 'Large',
        price: 0,
        cost: 0,
        stock: 0,
      },
    ],
  },
  {
    name: 'Colour',
    options: [
      {
        option: 'Green',
        price: 0,
        cost: 0,
        stock: 10,
      },
      {
        option: 'White',
        price: 0,
        cost: 0,
        stock: 10,
      },
      {
        option: 'Red',
        price: 0,
        cost: 0,
        stock: 0,
      },
    ],
  },
]

return (_ctx: any,_cache: any) => {
  const _component_k_divider = _resolveComponent("k-divider")!
  const _component_k_table = _resolveComponent("k-table")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.variations, (variation, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: index,
      class: "BaseItemDialog__section flex-1"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(variation.name), 1),
        _createVNode(_component_k_divider, { size: "md" })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_k_table, {
          columns: columns,
          rows: variation.options,
          "has-footer": false
        }, {
          stock: _withCtx(({ col }) => [
            _createElementVNode("span", {
              class: _normalizeClass([col.value === 0 ? 'text-error-70' : ''])
            }, _toDisplayString(col.value), 3)
          ]),
          _: 1
        }, 8, ["rows"])
      ])
    ]))
  }), 128))
}
}

})